/* Keep the visible Plaxar price and the cart variant in sync.
   This lives in the theme because GemPages regenerates its page script on publish. */
(function () {
  var initialVariantId = new URLSearchParams(window.location.search).get('variant');
  var productSelector = '#m-1622609367874';
  var swatchSelector = '#m-1790122586382 .gf_swatch';
  var initialized = false;
  var tries = 0;

  function start() {
    if (initialized) return true;
    var root = document.querySelector(productSelector);
    var price = root && root.querySelector('.gf_product-price');
    var productJson = root && root.querySelector('.product-json');
    if (!root || !price || !productJson || !window.GEMSTORE ||
        typeof window.GEMSTORE.subscribe !== 'function' ||
        !window.Shopify || typeof window.Shopify.formatMoney !== 'function' ||
        !window.money_format || !document.querySelector(swatchSelector)) return false;

    var product;
    try { product = JSON.parse(productJson.textContent); }
    catch (error) { return false; }
    if (!product || !Array.isArray(product.variants)) return false;
    initialized = true;

    function findVariant(id) {
      return product.variants.find(function (variant) { return String(variant.id) === String(id); });
    }
    function displayVariant(variant) {
      if (!variant) return;
      price.innerHTML = window.Shopify.formatMoney(variant.price, window.money_format);
      var compare = root.querySelector('.gf_product-compare-price');
      if (compare) compare.innerHTML = variant.compare_at_price > variant.price
        ? window.Shopify.formatMoney(variant.compare_at_price, window.money_format) : '';
    }
    function formVariant() {
      var input = root.querySelector('form.AddToCartForm input[name="id"]');
      return input && findVariant(input.value);
    }

    window.GEMSTORE.subscribe('product-' + root.id + '-variant', displayVariant);
    root.addEventListener('click', function (event) {
      if (!event.target.closest(swatchSelector)) return;
      window.setTimeout(function () { displayVariant(formVariant()); }, 50);
      window.setTimeout(function () { displayVariant(formVariant()); }, 250);
    });

    var requested = initialVariantId && findVariant(initialVariantId);
    if (requested) {
      var attempts = 0;
      var align = window.setInterval(function () {
        attempts++;
        var selected = document.querySelector(swatchSelector + '.gf_selected');
        var formMatches = formVariant() && String(formVariant().id) === String(requested.id);
        var swatchMatches = selected && selected.getAttribute('data-value') === requested.option1;
        if (formMatches && swatchMatches || attempts > 12) {
          window.clearInterval(align);
          displayVariant(formVariant());
          return;
        }
        var swatch = Array.prototype.find.call(document.querySelectorAll(swatchSelector), function (item) {
          return item.getAttribute('data-value') === requested.option1;
        });
        if (swatch) swatch.click();
      }, 250);
    } else {
      displayVariant(formVariant());
    }
    return true;
  }

  var timer = window.setInterval(function () {
    tries++;
    if (start() || tries > 80) window.clearInterval(timer);
  }, 100);
})();
